export default "assets/images/icons/picto-33828eee.svg";